import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ProjectControllerService } from '../../services/project-controller/project-controller.service';
import { TreeData } from './tree-selector';
import { MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tree-selector',
  imports: [CommonModule, MatChipsModule],
  templateUrl: './tree-selector.component.html',
  styleUrl: './tree-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreeSelectorComponent implements OnInit, OnDestroy {
  public changeSelectedMaterialNames: OutputEmitterRef<Array<string>> = output();

  public tree: Array<any> = [];
  public selectedTree: Array<Array<TreeData>> = [];

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private projectController: ProjectControllerService,
    private cd: ChangeDetectorRef,
  ) {}
  //--------------------------------------------------------------------------------
  // @ Lifecycle hooks
  //--------------------------------------------------------------------------------
  ngOnInit(): void {
    this.getProject();
  }
  ngOnDestroy(): void {}

  //--------------------------------------------------------------------------------
  // @ Public methods
  //--------------------------------------------------------------------------------
  public onClickAllCheckout(idx1: number): void {
    if (this.isAllCheckout(idx1 - 1, idx1)) {
      this.selectedTree[idx1] = [];
      this.changeSelectedMaterialNames.emit([]);
    } else {
      this.selectedTree[idx1] = this.selectedTree[idx1 - 1][0].child;
      this.changeSelectedMaterialNames.emit(this.selectedTree[idx1].map((i) => i.name));
    }
  }

  public isAllCheckout(idx1: number, idx2: number): boolean {
    const parent = this.selectedTree[idx1]?.[0];
    const selected = this.selectedTree[idx2];

    if (!parent || !selected) return false;

    const parentChildUUIDs = (parent.child ?? []).map((child) => child.uuid).sort();
    const selectedUUIDs = selected.map((item) => item.uuid).sort();

    if (parentChildUUIDs.length === 0) return false;
    if (parentChildUUIDs.length !== selectedUUIDs.length) return false;

    return parentChildUUIDs.every((uuid, idx) => uuid === selectedUUIDs[idx]);
  }

  public checkSelectedTree(index: number, item: TreeData): boolean {
    let boolean = false;
    if (this.selectedTree[index]?.includes(item)) boolean = true;
    return boolean;
  }

  public onClickPart(index: number, item: TreeData): void {
    if (index == 0) {
      if (this.selectedTree[index][0] == item) return;
      this.selectedTree[index] = [item];
      this.selectedTree[index + 1] = [...item.child];
      this.changeSelectedMaterialNames.emit(this.selectedTree[index + 1].map((i) => i.name));
    } else {
      if (this.selectedTree[index].includes(item)) {
        this.selectedTree[index] = this.selectedTree[index].filter((i) => i !== item);
      } else {
        this.selectedTree[index].push(item);
      }
      this.changeSelectedMaterialNames.emit(this.selectedTree[index].map((i) => i.name));
    }

    this.cd.markForCheck();
  }

  //--------------------------------------------------------------------------------
  // @ Private methods
  //--------------------------------------------------------------------------------

  private getProject(): void {
    this.projectController.project$.pipe(takeUntil(this._unsubscribeAll)).subscribe((project) => {
      if (!project || !project.baseModels || !project.baseModels[0]) return;
      project.baseModels[0].child.forEach((item) => this.traverseTree(item, 0));
      this.cd.markForCheck();
    });
  }

  private traverseTree(child: any, index: number): void {
    if (!this.tree[index]) {
      this.tree[index] = [];
      if (index == 0) {
        this.selectedTree[index] = [child];
        this.selectedTree[index + 1] = [...child.child];
        this.changeSelectedMaterialNames.emit(this.selectedTree[index + 1].map((i) => i.name));
      }
    }
    this.tree[index].push(child);
    if (child.child.length > 0)
      child.child.forEach((item: TreeData) => this.traverseTree(item, index + 1));

    this.cd.markForCheck();
  }
}
